import React from "react";
import { Grid } from "Components/Base/Layout/Grid";

const BaseGrid = ({
  children,
  spacing = 2,
  childWidth = "100%",
  justifyContent,
  alignItems,
  direction = "row",
  wrap = "wrap",
  p,
  pt,
  pr,
  pb,
  pl,
  width,
}) => {
  // Ta bort denna check vid övergång till Typescript
  if (
    !children ||
    React.Children.toArray(children).filter(Boolean).length === 0
  ) {
    return <></>;
  }

  return (
    <Grid
      container
      spacing={spacing}
      alignItems={alignItems}
      justifyContent={justifyContent}
      direction={direction}
      wrap={wrap}
      p={p}
      pt={pt}
      pr={pr}
      pb={pb}
      pl={pl}
      width={width}
      data-testid="basegrid-component"
    >
      {Array.isArray(children) ? (
        children.map(
          (child, index) =>
            child && (
              <Grid
                item
                key={`gridchild-${index}`}
                style={{ width: childWidth }}
              >
                {child}
              </Grid>
            ),
        )
      ) : (
        <Grid item key={"gridchild"} style={{ width: childWidth }}>
          {children}
        </Grid>
      )}
    </Grid>
  );
};

export default BaseGrid;
